<div class="container">
    <div class="row">
        <div class="col-2 d-flex flex-column actions">
            <button *ngIf="lecture" class="btn btn-outline-warning"
                (click)="lecture=!lecture"><mat-icon>edit</mat-icon></button>
            <button *ngIf="!lecture" class="btn btn-outline-warning" (click)="save()"
                matTooltip="Enregistrer"><mat-icon>save</mat-icon></button>


            <button class="btn btn-outline-warning" (click)="openPreview()"
                matTooltip="Aperçu"><mat-icon>view_quilt</mat-icon></button>
            <button *ngIf="!lecture" class="btn btn-outline-warning" (click)="duplicate()"
                matTooltip="Dupliquer"><mat-icon>file_copy</mat-icon></button>
        </div>
        <div class="col-10" *ngIf="dynamicContent">
            <div class="row">
                <div class="col-6 reference">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Référence</mat-label>
                        <input matInput type="text" [(ngModel)]="dynamicContent.reference" [disabled]="lecture">
                    </mat-form-field>
                    <mat-icon class="convert" matTooltip="Convertir en URL" *ngIf="!lecture"
                        (click)="convertUrl()">trending_flat</mat-icon>
                </div>
                <div class="col-6 url">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>URL</mat-label>
                        <input matInput type="text" [(ngModel)]="dynamicContent.url" [disabled]="lecture">
                    </mat-form-field>

                </div>
            </div>
            <div class="row">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Contenu descriptif</mat-label>
                    <input matInput type="text" [(ngModel)]="dynamicContent.shortContent" [disabled]="lecture">
                </mat-form-field>
            </div>
            <div class="row">
                <div class="col-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Statut du contenu</mat-label>
                        <mat-select [(value)]="selectedStatus" [disabled]="lecture">
                            <mat-option *ngFor="let stat of status"
                                [value]="stat">{{stat.mapLocalLibelle|csTranslate:translateService.currentLang}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Ordre de publication</mat-label>
                        <input matInput type="number" min="0" [(ngModel)]="dynamicContent.publishedOrder"
                            [disabled]="lecture">
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Langue</mat-label>
                        <mat-select [(value)]="selectedLang" [disabled]="lecture">
                            <mat-option *ngFor="let lang of languages" [value]="lang">{{lang.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-4 text-center">
                    <button mat-raised-button class="btn-primary" (click)="filePicker.click()"
                        [disabled]="lecture">CHARGER UNE IMAGE</button>
                    <input #filePicker type="file" hidden (change)="setImage($event)">
                </div>
                <div class="col-8">
                    <mat-form-field appearance="outline" class="w-100" *ngIf="!dynamicContent?.image?.[0]?.url">
                        <mat-label>Photo URL (texte simple)</mat-label>
                        <input type="text" matInput [(ngModel)]="dynamicContent.image" placeholder="URL de l'image"
                            [disabled]="lecture">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100" *ngIf="dynamicContent?.image?.[0]?.url">
                        <mat-label>Photo URL (issue de la ressource)</mat-label>
                        <input type="text" matInput [value]="dynamicContent?.image?.[0]?.url"
                            placeholder="URL de l'image" [disabled]="lecture" (keyup)="changeImageUrl($event)">
                    </mat-form-field>
                </div>

            </div>
            <div class="row canvas" *ngIf="dynamicContent">
                <div class="row layout" *ngFor="let r of dynamicContent?.layout; let i = index">
                    <div class="p-2 col-{{c.column}}" *ngFor="let c of r; let j = index;">
                        <div class="layout-item-actions">
                            <mat-icon *ngIf="!lecture && (r.length < 4)" (click)="addColumn(r)" class="bloc-item-action"
                                matTooltip="Ajouter une colonne" matTooltipPosition="left">add</mat-icon>
                            <mat-icon *ngIf="!lecture" (click)="removeRow(i)" class="bloc-item-action"
                                matTooltip="Supprimer la ligne" matTooltipPosition="left">close</mat-icon>
                            <mat-icon *ngIf="!lecture && i > 0" (click)="moveUp(i)" class="bloc-item-action"
                                matTooltip="Déplacer la ligne vers le haut"
                                matTooltipPosition="left">arrow_upward</mat-icon>
                        </div>

                        <div class="bloc-item">
                            {{getDynamicContentValue(c.contentRef) ? getDynamicContentValue(c.contentRef) : '-'}}
                            <div class="bloc-item-actions">
                                <mat-icon *ngIf="!lecture" (click)="editBloc(c)" class="bloc-item-action"
                                    matTooltip="Modifier l'élément" matTooltipPosition="right">edit</mat-icon>
                                <mat-icon *ngIf="!lecture" (click)="removeColumn(c, r, i)" class="bloc-item-action"
                                    matTooltip="Supprimer l'élément" matTooltipPosition="right">close</mat-icon>

                            </div>
                            <div class="bloc-item-actions">
                                <mat-icon *ngIf="!lecture && ( r.length > 1) && (j < r.length - 1)"
                                    (click)="moveToRight(i, j)" class="bloc-item-action" style="margin-left: auto;"
                                    matTooltip="Décaler l'élément à droite"
                                    matTooltipPosition="right">arrow_forward</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!lecture" class="layout p-2 col-12 d-flex justify-content-center align-items-center"
                    (click)="addRow()" style="color: white; cursor: pointer;">
                    {{'Ajouter une ligne'}}
                </div>
            </div>
        </div>
    </div>
</div>